import React from 'react';
import {Link} from 'react-router-dom';
import {IconTelegram} from '../../components/UI/NavIcons';
import {LAYOUT_SHELL_CLASS, PRIVACY_ROUTE, TELEGRAM_URL} from '../../util/Constants';

const Footer = () => {
    const year = new Date().getFullYear();
    const telegramHref = TELEGRAM_URL.trim() || 'https://t.me/lutica_candle_shop';
    const orgName = 'Кулиева Анастасия Михайловна, плательщик НПД (ИНН 784804153300)'

    return (
        <footer className="mt-auto w-full border-t border-stone-200/80 bg-cream-100/95 pb-[max(0.25rem,env(safe-area-inset-bottom,0px))] backdrop-blur-md">
            <div
                className={`${LAYOUT_SHELL_CLASS} flex flex-wrap items-center justify-center gap-x-2.5 gap-y-1.5 py-2 text-center text-[9px] leading-tight text-bark-500 sm:gap-x-3 sm:text-[10px] sm:leading-snug min-[1100px]:flex-nowrap min-[1100px]:overflow-x-auto min-[1100px]:[scrollbar-width:thin]`}
            >
                <span
                    className="min-w-0 min-[1100px]:shrink-0 min-[1100px]:whitespace-nowrap [overflow-wrap:anywhere] text-bark-500"
                >
                    © {year} ЛЮТИКА {orgName}
                </span>
                <span
                    className="hidden h-2 w-px shrink-0 bg-stone-300 min-[1100px]:block"
                    aria-hidden
                />
                <Link
                    to={PRIVACY_ROUTE}
                    className="shrink-0 font-medium text-pine-800 underline-offset-2 touch-manipulation hover:text-pine-900 hover:underline min-[1100px]:whitespace-nowrap"
                >
                    Политика обработки персональных данных
                </Link>
                <a
                    href={telegramHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-pine-800/90 transition touch-manipulation hover:bg-white/70 hover:text-pine-900 sm:h-6 sm:w-6"
                    aria-label="Telegram"
                    title="Telegram"
                >
                    <IconTelegram className="h-3 w-3 sm:h-3.5 sm:w-3.5" />
                </a>
            </div>
        </footer>
    );
};

export default Footer;
